/*************************************************/
/* DEPARTMENTS FILTER                            */
/*************************************************/

export function departmentsFilter() {
   const departmentSelectElementId = '#departmentSelect';
   const departmentElementSelector = '.department';
   const resetFilterSelectValue = 'all';


    const init = () => {
        const selectElement = document.querySelector(departmentSelectElementId);
        if(selectElement != null) {
            selectElement.addEventListener('change', e => {
                const selectedDepartmentId = e.target.value;
                const departments = document.querySelectorAll(departmentElementSelector);
                if(departments != null) {
                    departments.forEach(department => {
                        if(selectedDepartmentId == resetFilterSelectValue) {
                            department.style.display = "block"
                        }else {
                            if(department.id != selectedDepartmentId) {
                                department.style.display = "none"
                            }else {
                                department.style.display = "block"
    
                            }
                        }
                        
                    });
                }
            });
        }
    };

    init();
}

